import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid, Link } from '@material-ui/core';
import { FHEContainerForm, FHEContainerScroll, FHEItemText, ProductTitle } from 'data/components';
import { Logger } from 'data/common';

class SmartPlugBasicForm extends PureComponent {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        identifier: PropTypes.string,
        homeId: PropTypes.number,
        homeLabel: PropTypes.string,
        type: PropTypes.string,
        label: PropTypes.string,
        version: PropTypes.string,
        status: PropTypes.string,
        children: PropTypes.object,
        refreshStatusProduct: PropTypes.func,
        classes: PropTypes.object.isRequired
    };

    static defaultProps = {
        identifier: null,
        homeId: null,
        homeLabel: null,
        type: null,
        label: null,
        version: null,
        status: null,
        children: null,
        refreshStatusProduct: null
    };

    componentDidMount() {
        const { profile, history } = this.props;
        const userRight = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('products_smart_plug_details');
        if (!userRight) {
            Logger.verbose('Redirect to 403');
            return history.replace('/error/403');
        }
    }

    refreshStatusProduct = () => {
        const { identifier, refreshStatusProduct } = this.props;
        return refreshStatusProduct('smart_plug', identifier);
    };

    navigateToHomeDetail = () => {
        const { homeId, history } = this.props;
        return history.push({
            pathname: `/fhe/home/detail/${homeId}`
        });
    };

    render() {
        const { classes, identifier, homeId, homeLabel, type, label, version, status, children, profile } = this.props;
        const userRightRefreshStatus = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes(`products_${type}_refreshStatus`);
        const userRightHomeDetails = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('homeDetails');

        return (
            <Fragment>
                <ProductTitle homeLabel={homeLabel} type={type} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.identifier')}
                                    itemContent={identifier ? identifier.match(/.{1,2}/g).join(':') : 'N/A'}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('general.showDetail')}
                                    itemTitle={Translator.translate('general.table.column.homeLabel')}
                                    itemContent={
                                        userRightHomeDetails ? (
                                            <Link component="button" onClick={this.navigateToHomeDetail}>
                                                {`#${homeId} ${homeLabel}`}
                                            </Link>
                                        ) : (
                                            `#${homeId} ${homeLabel}`
                                        )
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.type')} itemContent={type} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.label')} itemContent={label} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.version')} itemContent={version} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('generic.products.table.action.refresh.tooltip')}
                                    onClick={userRightRefreshStatus ? this.refreshStatusProduct : null}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${status}`)}
                                    classContent={status === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    {children}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const productKey = props.productKey;
    const product = state.environments.fhe.data.Products.getIn(['list', productKey], new Map());
    const homes = state.environments.fhe.data.Homes.get('list');
    return {
        profile: state.data.user,
        identifier: product.get('identifier'),
        homeId: product.get('homeId'),
        homeLabel: homes.getIn([product.get('homeId').toString(), 'label'], ''),
        type: product.get('type'),
        label: product.get('label'),
        version: product.get('version'),
        status: product.get('status')
    };
}

const styles = theme => ({
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(SmartPlugBasicForm)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/SmartPlug/BasicForm/index.js